import { formatLocDateMMDDYY } from '@mummssoftware/utils/formatters';

import defaults from '../../translations/en.json';

/** Short due copy for ribbon tooltip (MM/DD/YY from requiredDateShifted). */
export const buildElectionAddendumDueMessage = (
  requiredDateShifted: number,
): string => {
  const date = formatLocDateMMDDYY(requiredDateShifted);
  return defaults.electionAddendumDue.replace('{date}', date);
};

/** Visit-header chip tooltip: visit has EAC, a new EA is owed from a later visit. */
export const buildElectionAddendumOwedLaterMessage = (
  requiredDateShifted: number,
): string => {
  const date = formatLocDateMMDDYY(requiredDateShifted);
  return defaults.electionAddendumCompletedOwedLater.replace('{date}', date);
};
